export const selectRegions = ({ fullList }) => (fullList && fullList[0] ? fullList[0] : []);
export const selectApplicationStatuses = ({ fullList }) =>
  fullList && fullList[4] ? fullList[4] : [];

export const selectApplicationStatusTitles = ({ newDictionaries }) =>
  newDictionaries?.appStatuses || {};
